export { LocationService } from './service.es.js';
